import { useState, type FormEvent } from 'react';

import Avatar from '../components/Common/Avatar';
import useAuth from '../hooks/useAuth';

const Profile = () => {
  const { user, updateProfile } = useAuth();
  const [displayName, setDisplayName] = useState(user?.profile.displayName ?? '');
  const [avatarUrl, setAvatarUrl] = useState(user?.profile.avatarUrl ?? '');
  const [styleProfile, setStyleProfile] = useState(
    user?.profile.styleProfile ?? '',
  );
  const [saving, setSaving] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);

  if (!user) return null;

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setSaving(true);
    setNotice(null);
    try {
      await updateProfile({
        displayName,
        avatarUrl: avatarUrl || null,
        styleProfile: styleProfile || null,
      });
      setNotice('Profiel opgeslagen.');
    } catch {
      setNotice('Het profiel kon niet worden opgeslagen.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="content-page">
      <header className="page-heading">
        <p className="eyebrow">Account</p>
        <h1>Profiel en antwoordstijl</h1>
        <p>
          De antwoordstijl wordt alleen door de backend met de gekozen AI-provider
          gedeeld wanneer automode veilig actief is.
        </p>
      </header>
      <section className="settings-card profile-card">
        <div className="profile-summary">
          <Avatar
            src={avatarUrl}
            alt={displayName || user.username}
            size={72}
          />
          <div>
            <strong>{displayName || user.username}</strong>
            <span>{user.email}</span>
            <span>{user.role === 'admin' ? 'Beheerder' : 'Medewerker'}</span>
          </div>
        </div>
        <form className="form-stack" onSubmit={handleSubmit}>
          <label>
            Weergavenaam
            <input
              value={displayName}
              onChange={(event) => setDisplayName(event.target.value)}
              minLength={1}
              maxLength={100}
              disabled={saving}
              required
            />
          </label>
          <label>
            Avatar-URL (alleen dezelfde beveiligde origin)
            <input
              type="url"
              value={avatarUrl}
              onChange={(event) => setAvatarUrl(event.target.value)}
              maxLength={2048}
              disabled={saving}
            />
          </label>
          <label>
            Gewenste antwoordstijl
            <textarea
              value={styleProfile}
              onChange={(event) => setStyleProfile(event.target.value)}
              rows={7}
              maxLength={4000}
              disabled={saving}
              placeholder="Bijvoorbeeld: vriendelijk, zakelijk en kort; spreek klanten aan met u."
            />
          </label>
          {notice && (
            <p className="notice" role="status">
              {notice}
            </p>
          )}
          <button className="button primary" disabled={saving}>
            {saving ? 'Opslaan…' : 'Profiel opslaan'}
          </button>
        </form>
      </section>
    </main>
  );
};

export default Profile;